
// import React, { useEffect, useRef, useState } from 'react';
// import { FileText, Upload, Save, AlertCircle, Info, Loader, CheckCircle, X, Trash2 } from 'lucide-react';
// import styles from './Serviceaggrementform.module.css';
// import SignatureCanvas from './SignatureCanvas';
// import { upload, getConsent, createConsent, deleteFiles } from '../../Config/api';

// export default function ServiceAgreementForm({ onSubmitSuccess }) {
//   const [formData, setFormData] = useState({});
//   const [files, setFiles] = useState({});
//   const [uploadedFiles, setUploadedFiles] = useState({});
//   const [fileBlobNames, setFileBlobNames] = useState({});
//   const [uploadingFiles, setUploadingFiles] = useState({});
//   const [uploadErrors, setUploadErrors] = useState({});
//   const [signatures, setSignatures] = useState({
//     investigator: null,
//     authorized_signatory_cro: null,
//   });
//   const [signatureData, setSignatureData] = useState(null);
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [jsonResponse, setJsonResponse] = useState(null);
//   const [isLoading, setIsLoading] = useState(true);
//   const [fetchError, setFetchError] = useState(null);
//   const [showSuccessModal, setShowSuccessModal] = useState(false);
//   const [consentId, setConsentId] = useState(null);
//   const [userId, setUserId] = useState(null);
//   const [snackbar, setSnackbar] = useState({ show: false, message: '', type: 'error' });
//   const [validationErrors, setValidationErrors] = useState({});
//   const [deletingFiles, setDeletingFiles] = useState({});

//   const investigatorSigRef = useRef(null);
//   const croSigRef = useRef(null);
//   const investigatorSectionRef = useRef(null);
//   const paymentSectionRef = useRef(null);
//   const signatureSectionRef = useRef(null);

//   useEffect(() => {
//     if (snackbar.show) {
//       const timer = setTimeout(() => {
//         setSnackbar({ ...snackbar, show: false });
//       }, 5000);
//       return () => clearTimeout(timer);
//     }
//   }, [snackbar.show]);

//   const showSnackbar = (message, type = 'error') => {
//     setSnackbar({ show: true, message, type });
//   };

//   useEffect(() => {
//     const fetchConsentData = async () => {
//       setIsLoading(true);
//       setFetchError(null);
//       try {
//         const response = await getConsent();
//         console.log('Consent data fetched:', response.data);



//         const responseData = response.data.data || response.data;

//         if (responseData.id) {
//           setConsentId(responseData.id);
//           console.log('Consent ID:', responseData.id);
//         }

//         const formContent = responseData.content || responseData;
//         setJsonResponse(formContent);

//         console.log('Form Content:', formContent);

//       } catch (error) {
//         console.error('Error fetching consent data:', error);
//         setFetchError(error.response?.data?.message || 'Failed to load form data. Please try again.');
//       } finally {
//         setIsLoading(false);
//       }
//     };

//     fetchConsentData();
//   }, []);

//   useEffect(() => {
//     if (jsonResponse) {
//       const userDetails = JSON.parse(localStorage.getItem('user')) || {};

//       if (userDetails.userId) {
//         setUserId(userDetails.userId);
//         console.log('User ID:', userDetails.userId);
//       }

//       console.log('===== AUTO-FILL DEBUG =====');
//       console.log('User Details:', userDetails);
//       console.log('Full Name:', userDetails.fullName);
//       console.log('Site Code:', userDetails.site?.siteCode);
//       console.log('Site Name:', userDetails.site?.siteName);

//       setTimeout(() => {
//         setFormData((prev) => {
//           const updates = {
//             ...prev,
//             'investigator.full_name': userDetails.fullName || '',
//             'investigator.site_code_&_site_name': `${userDetails.site?.siteCode}_${userDetails.site?.siteName}` || '',
//           };

//           console.log('Setting formData to:', updates);
//           return updates;
//         });
//       }, 100);

//       console.log('===== END AUTO-FILL DEBUG =====');
//     }
//   }, [jsonResponse]);

//   const handleInputChange = (key, value) => {
//     console.log('Input changed:', key, 'Value:', value);
//     setFormData((prev) => {
//       const updated = { ...prev, [key]: value };
//       console.log('Updated formData:', updated);
//       return updated;
//     });

//     if (validationErrors[key]) {
//       setValidationErrors((prev) => {
//         const updated = { ...prev };
//         delete updated[key];
//         return updated;
//       });
//     }
//   };

//   const handleFileChange = async (key, file) => {
//     if (!file) return;

//     setFiles((prev) => ({ ...prev, [key]: file }));
//     setUploadErrors((prev) => ({ ...prev, [key]: null }));
//     setUploadingFiles((prev) => ({ ...prev, [key]: true }));

//     try {
//       const formData = new FormData();
//       formData.append('file', file);

//       console.log('Uploading file:', file.name);

//       const response = await upload(formData);

//       console.log('Full upload response:', response);

//       let fileUrl = null;
//       let blobName = null;
//       let originalName = null

//       if (response.files && response.files.length > 0) {
//         fileUrl = response.files[0].url;
//         blobName = response.files[0].blobName;
//         originalName = response.files[0].originalName;
//       } else if (response.data && response.data.files && response.data.files.length > 0) {
//         fileUrl = response.data.files[0].url;
//         blobName = response.data.files[0].blobName;
//         originalName = response.data.files[0].originalName;
//       } else if (response.file) {
//         fileUrl = response.file.url;
//         blobName = response.file.blobName;
//       } else if (response.data && response.data.file) {
//         fileUrl = response.data.file.url;
//         blobName = response.data.file.blobName;
//       } else if (response.data) {
//         fileUrl = response.data.url;
//         blobName = response.data.blobName;
//       }

//       console.log('Extracted file URL:', fileUrl);
//       console.log('Extracted blob name:', blobName);

//       if (!fileUrl || typeof fileUrl !== 'string') {
//         console.error('Could not extract URL from response');
//         throw new Error('File uploaded but URL not found in response');
//       }

//       if (!blobName || typeof blobName !== 'string') {
//         console.error('Could not extract blobName from response');
//         throw new Error('File uploaded but blobName not found in response');
//       }

//       setUploadedFiles((prev) => ({
//         ...prev,
//         [key]: { filename: blobName, originalName }
//       }));

//       setFileBlobNames((prev) => ({
//         ...prev,
//         [key]: blobName
//       }));

//       console.log(`File URL stored for ${key}:`, fileUrl);
//       console.log(`Blob name stored for ${key}:`, blobName);
//       showSnackbar('File uploaded successfully', 'success');

//       if (validationErrors[key]) {
//         setValidationErrors((prev) => {
//           const updated = { ...prev };
//           delete updated[key];
//           return updated;
//         });
//       }
//     } catch (error) {
//       console.error(`Error uploading file for ${key}:`, error);
//       const errorMessage = error.response?.data?.message || error.message || 'Failed to upload file. Please try again.';

//       setUploadErrors((prev) => ({
//         ...prev,
//         [key]: errorMessage
//       }));

//       showSnackbar(errorMessage, 'error');

//       setFiles((prev) => {
//         const newFiles = { ...prev };
//         delete newFiles[key];
//         return newFiles;
//       });
//     } finally {
//       setUploadingFiles((prev) => ({ ...prev, [key]: false }));
//     }
//   };

//   const handleRemoveFile = async (key) => {
//     const blobName = fileBlobNames[key];

//     if (!blobName) {
//       setFiles((prev) => {
//         const newFiles = { ...prev };
//         delete newFiles[key];
//         return newFiles;
//       });
//       return;
//     }

//     setDeletingFiles((prev) => ({ ...prev, [key]: true }));

//     try {
//       console.log('Deleting file with blobName:', blobName);

//       await deleteFiles({ filename: blobName });

//       setFiles((prev) => {
//         const newFiles = { ...prev };
//         delete newFiles[key];
//         return newFiles;
//       });

//       setUploadedFiles((prev) => {
//         const newFiles = { ...prev };
//         delete newFiles[key];
//         return newFiles;
//       });

//       setFileBlobNames((prev) => {
//         const newBlobNames = { ...prev };
//         delete newBlobNames[key];
//         return newBlobNames;
//       });

//       setUploadErrors((prev) => {
//         const newErrors = { ...prev };
//         delete newErrors[key];
//         return newErrors;
//       });

//       showSnackbar('File removed successfully', 'success');
//     } catch (error) {
//       console.error('Error deleting file:', error);
//       showSnackbar('Failed to delete file. Please try again.', 'error');
//     } finally {
//       setDeletingFiles((prev) => ({ ...prev, [key]: false }));
//     }
//   };

//   const handleSignatureDrawn = (signatureDataUrl) => {
//     console.log('Signature drawn, storing data...');
//     setSignatureData(signatureDataUrl);

//     if (validationErrors['signature']) {
//       setValidationErrors((prev) => {
//         const updated = { ...prev };
//         delete updated['signature'];
//         return updated;
//       });
//     }
//   };

//   const handleSignatureUpload = async (key) => {
//     if (!signatureData) {
//       showSnackbar('Please draw your signature first', 'error');
//       return;
//     }

//     console.log('Uploading signature...');

//     setUploadingFiles((prev) => ({ ...prev, signature: true }));

//     try {
//       const blob = await fetch(signatureData).then(res => res.blob());
//       const file = new File([blob], `signature-${Date.now()}.png`, { type: 'image/png' });

//       const formData = new FormData();
//       formData.append('file', file);

//       const response = await upload(formData);

//       console.log('Signature upload response:', response);

//       let signatureUrl = null;
//       let signatureBlobName = null;
//       let originalName = null;

//       if (response.files && response.files.length > 0) {
//         signatureUrl = response.files[0].url;
//         signatureBlobName = response.files[0].blobName;
//         originalName = response.files[0].originalName;
//       } else if (response.data && response.data.files && response.data.files.length > 0) {
//         signatureUrl = response.data.files[0].url;
//         signatureBlobName = response.data.files[0].blobName;
//         originalName = response.data.files[0].originalName;
//       } else if (response.file) {
//         signatureUrl = response.file.url;
//         signatureBlobName = response.file.blobName;
//         originalName = response.file.originalName;
//       } else if (response.data && response.data.file) {
//         signatureUrl = response.data.file.url;
//         signatureBlobName = response.data.file.blobName;
//         originalName = response.data.file.originalName;
//       } else if (response.data) {
//         signatureUrl = response.data.url;
//         signatureBlobName = response.data.blobName;
//         originalName = response.data.originalName;
//       }

//       if (!signatureUrl || typeof signatureUrl !== 'string') {
//         throw new Error('Signature uploaded but URL not found in response');
//       }

//       if (!signatureBlobName || typeof signatureBlobName !== 'string') {
//         throw new Error('Signature uploaded but blobName not found in response');
//       }

//       // Store in the same format as regular file uploads
//       setUploadedFiles((prev) => ({
//         ...prev,
//         'signatures.investigator': { filename: signatureBlobName, originalName }
//       }));

//       setFileBlobNames((prev) => ({
//         ...prev,
//         'signatures.investigator': signatureBlobName
//       }));

//       setSignatures((prev) => ({ ...prev, [key]: signatureUrl }));

//       console.log('Signature URL stored:', signatureUrl);
//       console.log('Signature blobName stored:', signatureBlobName);
//       console.log('Signature originalName stored:', originalName);
//       showSnackbar('Signature uploaded successfully', 'success');

//       if (validationErrors['signature']) {
//         setValidationErrors((prev) => {
//           const updated = { ...prev };
//           delete updated['signature'];
//           return updated;
//         });
//       }
//     } catch (error) {
//       console.error('Error uploading signature:', error);
//       showSnackbar('Failed to upload signature. Please try again.', 'error');
//     } finally {
//       setUploadingFiles((prev) => ({ ...prev, signature: false }));
//     }
//   };

//   const handleSignatureClear = async () => {
//     const signatureBlobName = fileBlobNames['signatures.investigator'];

//     if (signatureBlobName) {
//       setDeletingFiles((prev) => ({ ...prev, signature: true }));

//       try {
//         console.log('Deleting signature with blobName:', signatureBlobName);

//         await deleteFiles({ filename: signatureBlobName });

//         setSignatures((prev) => ({ ...prev, investigator: null }));
//         setSignatureData(null);

//         setUploadedFiles((prev) => {
//           const newFiles = { ...prev };
//           delete newFiles['signatures.investigator'];
//           return newFiles;
//         });

//         setFileBlobNames((prev) => {
//           const newBlobNames = { ...prev };
//           delete newBlobNames['signatures.investigator'];
//           return newBlobNames;
//         });

//         showSnackbar('Signature cleared successfully', 'success');
//       } catch (error) {
//         console.error('Error deleting signature:', error);
//         showSnackbar('Failed to delete signature. Please try again.', 'error');
//       } finally {
//         setDeletingFiles((prev) => ({ ...prev, signature: false }));
//       }
//     } else {
//       setSignatureData(null);
//     }
//   };

//   const formatLabel = (key) => {
//     return key
//       .split('_')
//       .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
//       .join(' ');
//   };

//   const scrollToSection = (sectionRef) => {
//     if (sectionRef && sectionRef.current) {
//       sectionRef.current.scrollIntoView({
//         behavior: 'smooth',
//         block: 'start'
//       });
//       setTimeout(() => {
//         window.scrollBy(0, -100);
//       }, 300);
//     }
//   };

//   const renderField = (key, field, parentKey = '') => {
//     const fullKey = parentKey ? `${parentKey}.${key}` : key;
//     const fieldKey = fullKey;
//     const hasError = validationErrors[fieldKey];

//     if (field?.type === 'text_box') {
//       return (
//         <div key={fullKey}>
//           <label className={styles.label}>
//             {formatLabel(key)}
//             {field.required && <span className={styles.required}>*</span>}
//           </label>
//           {field.requirement && (
//             <p className={styles.requirement}>({field.requirement})</p>
//           )}
//           <input
//             type='text'
//             value={formData[fieldKey] || ''}
//             name={fieldKey}
//             disabled={field?.disable || false}
//             onChange={(e) => handleInputChange(fieldKey, e.target.value)}
//             className={`${styles.input} ${hasError ? styles.inputError : ''}`}
//             placeholder={`Enter ${formatLabel(key).toLowerCase()}`}
//           />
//           {hasError && (
//             <p className={styles.errorText}>
//               <AlertCircle className={styles.errorIconSmall} />
//               {hasError}
//             </p>
//           )}
//         </div>
//       );
//     } else if (field?.type === 'file_upload') {
//       const isUploading = uploadingFiles[fullKey];
//       const isDeleting = deletingFiles[fullKey];
//       const isUploaded = uploadedFiles[fullKey];
//       const error = uploadErrors[fullKey];
//       const hasFileError = validationErrors[fullKey];

//       return (
//         <div key={fullKey}>
//           <label className={styles.label}>
//             {formatLabel(key)}
//             {field.required && <span className={styles.required}>*</span>}
//           </label>
//           {field.requirement && (
//             <p className={styles.requirement}>({field.requirement})</p>
//           )}
//           <div className={styles.fileInputWrapper}>
//             <input
//               type='file'
//               onChange={(e) => handleFileChange(fullKey, e.target.files[0])}
//               className={styles.fileInputHidden}
//               id={fullKey}
//               disabled={isUploading || isDeleting}
//               accept="*/*"
//             />
//             <label
//               htmlFor={fullKey}
//               className={`${styles.fileInputLabel} ${(isUploading || isDeleting) ? styles.fileInputDisabled : ''}`}
//             >
//               {isUploading ? (
//                 <>
//                   <Loader className={`${styles.icon} ${styles.spinning}`} />
//                   Uploading...
//                 </>
//               ) : (
//                 <>
//                   <Upload className={styles.icon} />
//                   Choose File
//                 </>
//               )}
//             </label>
//             {files[fullKey] && !error && (
//               <div className={styles.fileNameWrapper}>
//                 <span className={`${styles.fileName} ${isUploaded ? styles.fileNameSuccess : ''}`}>
//                   {files[fullKey].name}
//                   {isUploaded && ' ✓'}
//                 </span>
//                 <button
//                   type="button"
//                   onClick={() => handleRemoveFile(fullKey)}
//                   className={styles.removeFileButton}
//                   title="Remove file"
//                   disabled={isDeleting}
//                 >
//                   {isDeleting ? (
//                     <Loader className={styles.spinningSmall} size={16} />
//                   ) : (
//                     <Trash2 size={16} />
//                   )}
//                 </button>
//               </div>
//             )}
//             {error && (
//               <span className={styles.fileError}>
//                 <AlertCircle className={styles.errorIcon} />
//                 {error}
//               </span>
//             )}
//             {hasFileError && (
//               <p className={styles.errorText}>
//                 <AlertCircle className={styles.errorIconSmall} />
//                 {hasFileError}
//               </p>
//             )}
//           </div>
//         </div>
//       );
//     } else if (field?.type === 'date_field') {
//       return (
//         <div key={fullKey}>
//           <label className={styles.label}>
//             {formatLabel(key)}
//             {field.required && <span className={styles.required}>*</span>}
//           </label>
//           <input
//             type='date'
//             name={fieldKey}
//             value={formData[fieldKey] || ''}
//             onChange={(e) => handleInputChange(fieldKey, e.target.value)}
//             className={`${styles.input} ${hasError ? styles.inputError : ''}`}
//           />
//           {hasError && (
//             <p className={styles.errorText}>
//               <AlertCircle className={styles.errorIconSmall} />
//               {hasError}
//             </p>
//           )}
//         </div>
//       );
//     } else if (field?.type === 'electronic_signature') {
//       const signatureKey = fullKey.split('.').pop();
//       const isUploadingSignature = uploadingFiles['signature'];
//       const isDeletingSignature = deletingFiles['signature'];
//       const isSignatureUploaded = signatures[signatureKey];

//       return (
//         <div key={fullKey} className={styles.signatureSection}>
//           <SignatureCanvas
//             label={formatLabel(key)}
//             required={field.required}
//             onSignatureChange={handleSignatureDrawn}
//             onSignatureClear={handleSignatureClear}
//             disabled={isUploadingSignature || isDeletingSignature}
//           />

//           {signatureData && !isSignatureUploaded && (
//             <div className={styles.signatureActions}>
//               <button
//                 type="button"
//                 onClick={() => handleSignatureUpload(signatureKey)}
//                 className={styles.uploadSignatureButton}
//                 disabled={isUploadingSignature}
//               >
//                 {isUploadingSignature ? (
//                   <>
//                     <Loader className={`${styles.icon} ${styles.spinning}`} />
//                     Uploading Signature...
//                   </>
//                 ) : (
//                   <>
//                     <Upload className={styles.icon} />
//                     Upload Signature
//                   </>
//                 )}
//               </button>
//             </div>
//           )}

//           {isSignatureUploaded && (
//             <div className={styles.signatureUploaded}>
//               <CheckCircle className={styles.successIcon} />
//               <span>Signature uploaded successfully</span>
//             </div>
//           )}

//           <div className={styles.grid}>
//             {Object.entries(field)
//               .filter(([k]) => k !== 'type' && k !== 'required' && k !== 'name')
//               .map(([subKey, subValue]) =>
//                 renderField(subKey, subValue, fullKey)
//               )}
//           </div>
//         </div>
//       );
//     }
//     return null;
//   };

//   const renderSection = (sectionKey, sectionData) => {
//     if (typeof sectionData !== 'object' || Array.isArray(sectionData))
//       return null;
//     return (
//       <div className={styles.grid}>
//         {Object.entries(sectionData).map(([key, value]) => {
//           if (value?.type) {
//             return renderField(key, value, sectionKey);
//           } else if (
//             value &&
//             typeof value === 'object' &&
//             !Array.isArray(value)
//           ) {
//             return (
//               <div key={key} className={styles.nestedSection}>
//                 <h4 className={styles.sectionSubtitle}>{formatLabel(key)}</h4>
//                 <div className={styles.grid}>
//                   {Object.entries(value).map(([subKey, subValue]) =>
//                     renderField(subKey, subValue, `${sectionKey}.${key}`)
//                   )}
//                 </div>
//               </div>
//             );
//           }
//           return null;
//         })}
//       </div>
//     );
//   };

//   const renderInfoList = (items, title = '') => (
//     <div className={styles.infoList}>
//       {title && <h4 className={styles.infoListTitle}>{title}</h4>}
//       <ul className={styles.list}>
//         {items.map((item, idx) => (
//           <li key={idx} className={styles.listItem}>
//             <span className={styles.bullet}>•</span>
//             <span>{item}</span>
//           </li>
//         ))}
//       </ul>
//     </div>
//   );

//   const renderInfoObject = (obj, title = '') => (
//     <div className={styles.infoObject}>
//       {title && <h4 className={styles.infoListTitle}>{title}</h4>}
//       {Object.entries(obj).map(([key, value]) => (
//         <div key={key} className={styles.infoObjectItem}>
//           <span className={styles.infoObjectKey}>{formatLabel(key)}:</span>
//           <span className={styles.infoObjectValue}>{value}</span>
//         </div>
//       ))}
//     </div>
//   );

//   const validateForm = () => {
//     const errors = {};
//     let firstErrorSection = null;

//     console.log('===== FORM VALIDATION =====');
//     console.log('Form Data:', formData);
//     console.log('Uploaded Files:', uploadedFiles);
//     console.log('Signatures:', signatures);

//     const stillUploading = Object.values(uploadingFiles).some(status => status);
//     if (stillUploading) {
//       showSnackbar('Please wait for all files to finish uploading.', 'warning');
//       return false;
//     }

//     const hasUploadErrors = Object.values(uploadErrors).some(error => error);
//     if (hasUploadErrors) {
//       showSnackbar('Please fix file upload errors before submitting.', 'error');
//       return false;
//     }

//     const investigatorFields = {
//       'investigator.full_name': 'Full name is required',
//       'investigator.site_code_&_site_name': 'Site code & site name is required',
//       'investigator.medical_registration_no': 'Medical registration number is required'
//     };

//     Object.entries(investigatorFields).forEach(([fieldKey, errorMessage]) => {
//       if (!formData[fieldKey] || formData[fieldKey].trim() === '') {
//         errors[fieldKey] = errorMessage;
//         if (!firstErrorSection) firstErrorSection = investigatorSectionRef;
//       }
//     });

//     const paymentFields = {
//       'personal_information.full_name': 'Full name (as per PAN) is required',
//       'personal_information.clinic_address': 'Clinic address is required',
//       'personal_information.contact_number': 'Contact number is required',
//       'personal_information.alternate_email_address': 'Email address is required',
//       'bank_details.bank_name_address': 'Bank name & address is required',
//       'bank_details.account_holder_name': 'Account holder name is required',
//       'bank_details.account_number': 'Account number is required',
//       'bank_details.IFSC_code': 'IFSC code is required'
//     };

//     Object.entries(paymentFields).forEach(([fieldKey, errorMessage]) => {
//       if (!formData[fieldKey] || formData[fieldKey].trim() === '') {
//         errors[fieldKey] = errorMessage;
//         if (!firstErrorSection) firstErrorSection = paymentSectionRef;
//       }
//     });

//     const requiredFiles = {
//       'personal_information.medical_registration_number': 'Medical registration certificate is required',
//       'personal_information.pan_number': 'PAN card is required',
//       'bank_details.cancelled_cheque': 'Cancelled cheque is required'
//     };

//     Object.entries(requiredFiles).forEach(([fileKey, errorMessage]) => {
//       const fileUrl = uploadedFiles[fileKey]?.filename;

//       if (!fileUrl || typeof fileUrl !== 'string' || fileUrl.trim() === '') {
//         errors[fileKey] = errorMessage;
//         if (!firstErrorSection) firstErrorSection = paymentSectionRef;
//       }
//     });

//     if (!signatures.investigator) {
//       errors['signature'] = 'Signature is required';
//       if (!firstErrorSection) firstErrorSection = signatureSectionRef;
//     }

//     console.log('Total errors:', Object.keys(errors).length);
//     console.log('===== END VALIDATION =====');

//     setValidationErrors(errors);

//     if (Object.keys(errors).length > 0) {
//       showSnackbar('Please fill in all required fields', 'error');
//       if (firstErrorSection) {
//         scrollToSection(firstErrorSection);
//       }
//       return false;
//     }

//     return true;
//   };

//   const handleSubmit = async () => {
//     if (!validateForm()) return;

//     setIsSubmitting(true);

//     try {
//       const submissionData = {
//         userId: userId,
//         consentId: consentId,
//         formData: formData,
//         uploadedFiles: uploadedFiles,
//       };

//       console.log('Submitting Service Agreement...');
//       console.log('Submission Data:', submissionData);

//       const response = await createConsent(submissionData);

//       console.log('Submission Response:', response.data);

//       setShowSuccessModal(true);

//       setTimeout(() => {
//         setShowSuccessModal(false);
//         if (onSubmitSuccess) {
//           onSubmitSuccess();
//         }
//       }, 2000);

//     } catch (error) {
//       console.error('Error submitting form:', error);
//       const errorMessage = error.response?.data?.message ||
//         error.response?.data?.error ||
//         error.message ||
//         'Failed to submit form. Please try again.';
//       showSnackbar(errorMessage, 'error');
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   const handleCloseSuccessModal = () => {
//     console.log('Closing success modal and navigating...');

//     setShowSuccessModal(false);

//     setFormData({});
//     setFiles({});
//     setUploadedFiles({});
//     setFileBlobNames({});
//     setSignatures({
//       investigator: null,
//       authorized_signatory_cro: null,
//     });
//     setSignatureData(null);
//     setValidationErrors({});

//     console.log('Form data cleared, calling onSubmitSuccess...');

//     if (onSubmitSuccess) {
//       onSubmitSuccess();
//     }
//   };

//   if (isLoading) {
//     return (
//       <div className={styles.container}>
//         <div className={styles.loadingWrapper}>
//           <Loader className={`${styles.loadingIcon} ${styles.spinning}`} />
//           <p className={styles.loadingText}>Loading form data...</p>
//         </div>
//       </div>
//     );
//   }

//   if (fetchError) {
//     return (
//       <div className={styles.container}>
//         <div className={styles.errorWrapper}>
//           <AlertCircle className={styles.errorIconLarge} />
//           <h2 className={styles.errorTitle}>Failed to Load Form</h2>
//           <p className={styles.errorMessage}>{fetchError}</p>
//           <button
//             onClick={() => window.location.reload()}
//             className={styles.retryButton}
//           >
//             Retry
//           </button>
//         </div>
//       </div>
//     );
//   }

//   if (!jsonResponse) {
//     return null;
//   }

//   return (
//     <>
//       <div className={styles.container}>
//         <div className={styles.wrapper}>
//           <div className={styles.card}>
//             <div className={styles.header}>
//               <FileText className={styles.headerIcon} />
//               <div className={styles.headerContent}>
//                 <h1 className={styles.title}>{jsonResponse.document_title}</h1>
//                 <div className={styles.studyBox}>
//                   <p className={styles.studyLabel}>Study Title:</p>
//                   <p className={styles.studyTitle}>{jsonResponse.study_title}</p>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {jsonResponse.parties?.service_provider && (
//             <div className={styles.card}>
//               <div className={styles.sectionHeader}>
//                 <Info className={styles.sectionIcon} />
//                 <h2 className={styles.sectionTitle}>Service Provider</h2>
//               </div>
//               <p className={styles.infoText}>
//                 <span className={styles.infoLabel}>Name:</span>{' '}
//                 {jsonResponse.parties.service_provider.name}
//               </p>
//               <p className={styles.infoText}>
//                 <span className={styles.infoLabel}>Address:</span>{' '}
//                 {jsonResponse.parties.service_provider.address}
//               </p>
//             </div>
//           )}

//           {jsonResponse.parties?.investigator && (
//             <div className={styles.card} ref={investigatorSectionRef}>
//               <h2 className={styles.sectionTitle}>Investigator Information</h2>
//               {renderSection('investigator', jsonResponse.parties.investigator)}
//             </div>
//           )}

//           {jsonResponse.sections?.scope_of_services && (
//             <div className={styles.card}>
//               <h2 className={styles.sectionTitle}>Scope of Services</h2>
//               {jsonResponse.sections.scope_of_services.patient_enrollment &&
//                 renderInfoObject(
//                   jsonResponse.sections.scope_of_services.patient_enrollment
//                 )}
//               {jsonResponse.sections.scope_of_services.data_entry &&
//                 renderInfoObject(jsonResponse.sections.scope_of_services.data_entry)}
//               {jsonResponse.sections.scope_of_services.compliance?.standards &&
//                 renderInfoList(
//                   jsonResponse.sections.scope_of_services.compliance.standards,
//                   'Compliance Standards'
//                 )}
//             </div>
//           )}

//           {jsonResponse.sections?.compensation && (
//             <div className={styles.card}>
//               <h2 className={styles.sectionTitle}>Compensation Details</h2>
//               <div className={styles.compensationBox}>
//                 <p className={styles.compensationAmount}>
//                   {jsonResponse.sections.compensation.fee_per_patient}
//                 </p>
//               </div>

//               {jsonResponse.sections.compensation.payment_conditions &&
//                 renderInfoList(
//                   jsonResponse.sections.compensation.payment_conditions,
//                   'Payment Conditions'
//                 )}
//             </div>
//           )}

//           {jsonResponse.sections?.confidentiality && (
//             <div className={styles.card}>
//               <div className={styles.sectionHeader}>
//                 <AlertCircle className={styles.alertIcon} />
//                 <h2 className={styles.sectionTitle}>Confidentiality Agreement</h2>
//               </div>
//               <div className={styles.alertBox}>
//                 {renderInfoList(jsonResponse.sections.confidentiality)}
//               </div>
//             </div>
//           )}

//           {jsonResponse.data_protection && (
//             <div className={styles.card}>
//               <div className={styles.sectionHeader}>
//                 <AlertCircle className={styles.warningIcon} />
//                 <h2 className={styles.sectionTitle}>Data Protection</h2>
//               </div>
//               <div className={styles.warningBox}>
//                 {jsonResponse.data_protection.requirements &&
//                   renderInfoList(
//                     jsonResponse.data_protection.requirements,
//                     'Requirements'
//                   )}
//                 {jsonResponse.data_protection.security_responsibilities &&
//                   renderInfoList(
//                     jsonResponse.data_protection.security_responsibilities,
//                     'Security Responsibilities'
//                   )}
//               </div>
//             </div>
//           )}

//           {jsonResponse.independent_contractor && (
//             <div className={styles.card}>
//               <h2 className={styles.sectionTitle}>Independent Contractor Status</h2>
//               <p className={styles.infoText}>
//                 <span className={styles.infoLabel}>Status:</span>{' '}
//                 {jsonResponse.independent_contractor.status}
//               </p>
//               <p className={styles.infoText}>
//                 <span className={styles.infoLabel}>Responsibilities:</span>{' '}
//                 {jsonResponse.independent_contractor.responsibilities}
//               </p>
//             </div>
//           )}

//           {jsonResponse.term_termination && (
//             <div className={styles.card}>
//               <h2 className={styles.sectionTitle}>Term & Termination</h2>
//               <p className={styles.infoText}>
//                 {jsonResponse.term_termination.duration}
//               </p>
//             </div>
//           )}

//           {jsonResponse.governing_law && (
//             <div className={styles.card}>
//               <h2 className={styles.sectionTitle}>Governing Law</h2>
//               <p className={styles.infoText}>
//                 {jsonResponse.governing_law.jurisdiction}
//               </p>
//             </div>
//           )}

//           {jsonResponse.payment_verification_details && (
//             <div className={styles.card} ref={paymentSectionRef}>
//               <h2 className={styles.sectionTitle}>Payment Verification Details</h2>
//               {jsonResponse.payment_verification_details.personal_information && (
//                 <>
//                   <h3 className={styles.subsectionTitle}>Personal Information</h3>
//                   {renderSection(
//                     'personal_information',
//                     jsonResponse.payment_verification_details.personal_information
//                   )}
//                 </>
//               )}
//               {jsonResponse.payment_verification_details.bank_details && (
//                 <>
//                   <h3
//                     className={`${styles.subsectionTitle} ${styles.subsectionTitleSpaced}`}
//                   >
//                     Bank Details
//                   </h3>
//                   {renderSection(
//                     'bank_details',
//                     jsonResponse.payment_verification_details.bank_details
//                   )}
//                 </>
//               )}
//               {jsonResponse.payment_verification_details.data_usage_note && (
//                 <p className={styles.noteText}>
//                   {jsonResponse.payment_verification_details.data_usage_note}
//                 </p>
//               )}
//             </div>
//           )}

//           {jsonResponse.signatures && (
//             <div className={styles.card} ref={signatureSectionRef}>
//               <h2 className={styles.sectionTitle}>Signatures</h2>
//               {validationErrors['signature'] && (
//                 <div className={styles.signatureError}>
//                   <AlertCircle className={styles.errorIconSmall} />
//                   {validationErrors['signature']}
//                 </div>
//               )}
//               {renderSection('signatures', jsonResponse.signatures)}
//             </div>
//           )}

//           <div className={styles.submitWrapper}>
//             <button
//               onClick={handleSubmit}
//               className={styles.submitButton}
//               disabled={isSubmitting || Object.values(uploadingFiles).some(status => status)}
//             >
//               {isSubmitting ? (
//                 <>
//                   <Loader className={`${styles.buttonIcon} ${styles.spinning}`} />
//                   Submitting...
//                 </>
//               ) : (
//                 <>
//                   {/* <Save className={styles.buttonIcon} /> */}
//                   Submit Service Agreement
//                 </>
//               )}
//             </button>
//           </div>

//           <div className={styles.footer}>
//             <p>
//               All details will be stored securely and used only for administrative
//               purposes.
//             </p>
//           </div>
//         </div>
//       </div>

//       {showSuccessModal && (
//         <div className={styles.modalOverlay}>
//           <div className={styles.modalContent}>
//             <button
//               className={styles.modalClose}
//               onClick={handleCloseSuccessModal}
//               aria-label="Close"
//             >
//               <X size={24} />
//             </button>

//             <div className={styles.modalIcon}>
//               <CheckCircle size={64} />
//             </div>

//             <h2 className={styles.modalTitle}>Consent Submitted Successfully</h2>

//             <div className={styles.modalBody}>
//               <p>Your consent has been submitted for review and is currently awaiting verification.</p>
//               <p>You will receive a notification once the review is completed.</p>
//               <p className={styles.modalWarning}>
//                 Please wait for the approval before proceeding with subject creation or data entry.
//               </p>
//             </div>

//             <button
//               className={styles.modalButton}
//               onClick={handleCloseSuccessModal}
//             >
//               Close
//             </button>
//           </div>
//         </div>
//       )}

//       {snackbar.show && (
//         <div className={`${styles.snackbar} ${styles[`snackbar${snackbar.type.charAt(0).toUpperCase() + snackbar.type.slice(1)}`]} ${styles.snackbarShow}`}>
//           <AlertCircle className={styles.snackbarIcon} />
//           <span>{snackbar.message}</span>
//           <button
//             className={styles.snackbarClose}
//             onClick={() => setSnackbar({ ...snackbar, show: false })}
//           >
//             <X size={18} />
//           </button>
//         </div>
//       )}
//     </>
//   );
// }

import React, { useEffect, useRef, useState } from 'react';
import { FileText, Upload, Save, AlertCircle, Info, Loader, CheckCircle, X, Trash2 } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';
import styles from './Serviceaggrementform.module.css';
import SignatureCanvas from './SignatureCanvas';
import { upload, getConsent, createConsent, deleteFiles, getConsents } from '../../Config/api';

export default function ServiceAgreementForm({ onSubmitSuccess }) {
  const location = useLocation();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({});
  const [files, setFiles] = useState({});
  const [uploadedFiles, setUploadedFiles] = useState({});
  const [fileBlobNames, setFileBlobNames] = useState({});
  const [uploadingFiles, setUploadingFiles] = useState({});
  const [uploadErrors, setUploadErrors] = useState({});
  const [signatures, setSignatures] = useState({
    investigator: null,
    authorized_signatory_cro: null,
  });
  const [signatureData, setSignatureData] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [jsonResponse, setJsonResponse] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [fetchError, setFetchError] = useState(null);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [consentId, setConsentId] = useState(null);
  const [userId, setUserId] = useState(null);
  const [validationErrors, setValidationErrors] = useState({});
  const [deletingFiles, setDeletingFiles] = useState({});
  const [userConsentId, setUserConsentId] = useState(null);
  const [isResubmission, setIsResubmission] = useState(false);
  const [rejectionReason, setRejectionReason] = useState(null);
  const [showAlertModal, setShowAlertModal] = useState(false);
  const [alertModal, setAlertModal] = useState({ title: '', message: '', type: 'info' });
  const [submitError, setSubmitError] = useState(null);
  const [snackbar, setSnackbar] = useState({ show: false, message: '', type: 'success' });

  const investigatorSigRef = useRef(null);
  const croSigRef = useRef(null);
  const investigatorSectionRef = useRef(null);
  const paymentSectionRef = useRef(null);
  const signatureSectionRef = useRef(null);

  const showAlert = (title, message, type = 'info') => {
    setAlertModal({ title, message, type });
    setShowAlertModal(true);
  };

  const getUserIdFromStorage = () => {
    const userDetails = JSON.parse(localStorage.getItem('user')) || {};
    return userDetails.userId;
  };
  useEffect(() => {
    const fetchConsentData = async () => {
      console.log('========== FETCH CONSENT DATA START ==========');
      setIsLoading(true);
      setFetchError(null);

      const resubmitConsentId = location.state?.consentId;
      const isResubmit = location.state?.isResubmission;

      setIsResubmission(isResubmit || false);

      try {
        const userDetails = JSON.parse(localStorage.getItem('user')) || {};
        const currentUserId = userDetails.userId;

        if (currentUserId) {
          setUserId(currentUserId);
        }

        const formResponse = await getConsent();
        const responseData = formResponse.data.data || formResponse.data;

        console.log('Full responseData:', responseData);
        console.log('responseData.consent_id:', responseData.consent_id);
        console.log('responseData.user_consent_id:', responseData.user_consent_id);
        console.log('Has form structure (content)?', !!responseData.content);

        const isRejectedConsent = responseData.alreadyConsented && responseData.consentStatus === 'Rejected';

        if (isRejectedConsent) {
          console.log('>>> RESUBMISSION MODE');
          const rejectedConsent = responseData;

          const templateConsentId = rejectedConsent.consent_id;
          const userConsentIdValue = rejectedConsent.user_consent_id;

          console.log('🔍 templateConsentId:', templateConsentId);
          console.log('🔍 userConsentIdValue:', userConsentIdValue);
          console.log('🔍 responseData.id:', responseData.id);

          setConsentId(templateConsentId);
          setUserConsentId(userConsentIdValue);

          console.log('✅ Set consentId to:', templateConsentId);
          console.log('✅ Set userConsentId to:', userConsentIdValue);

          setRejectionReason(rejectedConsent.reason || 'Previous submission was rejected. Please review and correct the issues.');

          if (rejectedConsent.consentSubmission) {
            console.log('Setting form data:', rejectedConsent.consentSubmission);
            setFormData(rejectedConsent.consentSubmission);
          } else {
            setFormData({
              'investigator.full_name': userDetails.fullName || '',
              'investigator.site_code_&_site_name': `${userDetails.site?.siteCode}_${userDetails.site?.siteName}` || '',
            });
          }

          if (rejectedConsent.uploaded_docs) {
            let parsedDocs = rejectedConsent.uploaded_docs;

            if (typeof rejectedConsent.uploaded_docs === 'string') {
              parsedDocs = JSON.parse(rejectedConsent.uploaded_docs);
            }

            const mappedUploadedFiles = {};
            const blobNames = {};
            const fileObjects = {};

            const documentMapping = {
              'pancard': 'personal_information.pan_number',
              'medical_registration': 'personal_information.medical_registration_number',
              'cancelled_cheque': 'bank_details.cancelled_cheque',
              'investigator_signature': 'signatures.investigator'
            };

            Object.entries(parsedDocs).forEach(([docType, docInfo]) => {
              const formFieldKey = documentMapping[docType] || docType;

              if (docInfo?.filename) {
                mappedUploadedFiles[formFieldKey] = {
                  filename: docInfo.filename,
                  originalName: docInfo.originalName
                };
                blobNames[formFieldKey] = docInfo.filename;
                fileObjects[formFieldKey] = new File([], docInfo.originalName || docInfo.filename);
              }
            });

            console.log('Setting files:', mappedUploadedFiles);
            setUploadedFiles(mappedUploadedFiles);
            setFileBlobNames(blobNames);
            setFiles(fileObjects);

            if (mappedUploadedFiles['signatures.investigator']) {
              setSignatures(prev => ({
                ...prev,
                investigator: mappedUploadedFiles['signatures.investigator'].filename
              }));
            }
          }

          if (rejectedConsent.content) {
            console.log('Form structure found in content');
            setJsonResponse(rejectedConsent.content);
          } else {
            console.log('⚠️ No form structure in response, fetching template...');
            const templateResponse = await getConsent();
            const templateData = templateResponse.data;

            if (templateData.content) {
              console.log('Form structure found in template');
              setJsonResponse(templateData.content);
            } else {
              console.error('❌ Form structure not found!');
              setFetchError('Form template not found. Please contact support.');
            }
          }

        } else {
          console.log('>>> NEW SUBMISSION MODE');

          console.log('🔍 responseData.id:', responseData.id);

          if (responseData.id) {
            setConsentId(responseData.id);
            console.log('✅ Set consentId to:', responseData.id);
          } else {
            console.log('⚠️ No id found in responseData!');
          }
          setFormData({
            'investigator.full_name': userDetails.fullName || '',
            'investigator.site_code_&_site_name': `${userDetails.site?.siteCode}_${userDetails.site?.siteName}` || '',
          });

          if (responseData.content) {
            console.log('Form structure found');
            setJsonResponse(responseData.content);
          } else {
            console.error('❌ Form structure not found in response!');
            setFetchError('Form template not found. Please contact support.');
          }
        }

        console.log('========== FETCH CONSENT DATA END ==========');

      } catch (error) {
        console.error('ERROR:', error);
        setFetchError(error.response?.data?.message || 'Failed to load form data. Please try again.');
      } finally {
        setIsLoading(false);
      }
    };

    fetchConsentData();
  }, [location.state]);
  useEffect(() => {
    console.log('📊 STATE UPDATE - consentId:', consentId);
    console.log('📊 STATE UPDATE - userConsentId:', userConsentId);
  }, [consentId, userConsentId]);
  const handleInputChange = (key, value) => {
    console.log('Input changed:', key, 'Value:', value);
    setFormData((prev) => {
      const updated = { ...prev, [key]: value };
      console.log('Updated formData:', updated);
      return updated;
    });

    if (validationErrors[key]) {
      setValidationErrors((prev) => {
        const updated = { ...prev };
        delete updated[key];
        return updated;
      });
    }
  };

  const handleFileChange = async (key, file) => {
    if (!file) return;

    setFiles((prev) => ({ ...prev, [key]: file }));
    setUploadErrors((prev) => ({ ...prev, [key]: null }));
    setUploadingFiles((prev) => ({ ...prev, [key]: true }));

    try {
      const formData = new FormData();
      formData.append('file', file);

      console.log('Uploading file:', file.name);

      const response = await upload(formData);

      console.log('Full upload response:', response);

      let fileUrl = null;
      let blobName = null;
      let originalName = null;

      if (response.files && response.files.length > 0) {
        fileUrl = response.files[0].url;
        blobName = response.files[0].blobName;
        originalName = response.files[0].originalName;
      } else if (response.data && response.data.files && response.data.files.length > 0) {
        fileUrl = response.data.files[0].url;
        blobName = response.data.files[0].blobName;
        originalName = response.data.files[0].originalName;
      } else if (response.file) {
        fileUrl = response.file.url;
        blobName = response.file.blobName;
        originalName = response.file.originalName;
      } else if (response.data && response.data.file) {
        fileUrl = response.data.file.url;
        blobName = response.data.file.blobName;
        originalName = response.data.file.originalName;
      } else if (response.data) {
        fileUrl = response.data.url;
        blobName = response.data.blobName;
        originalName = response.data.originalName;
      }

      console.log('Extracted file URL:', fileUrl);
      console.log('Extracted blob name:', blobName);

      if (!fileUrl || typeof fileUrl !== 'string') {
        console.error('Could not extract URL from response');
        throw new Error('File uploaded but URL not found in response');
      }

      if (!blobName || typeof blobName !== 'string') {
        console.error('Could not extract blobName from response');
        throw new Error('File uploaded but blobName not found in response');
      }

      setUploadedFiles((prev) => ({
        ...prev,
        [key]: { filename: blobName, originalName }
      }));

      setFileBlobNames((prev) => ({
        ...prev,
        [key]: blobName
      }));

      console.log(`File URL stored for ${key}:`, fileUrl);
      console.log(`Blob name stored for ${key}:`, blobName);
      showAlert('Success', 'File uploaded successfully', 'success');

      if (validationErrors[key]) {
        setValidationErrors((prev) => {
          const updated = { ...prev };
          delete updated[key];
          return updated;
        });
      }
    } catch (error) {
      console.error(`Error uploading file for ${key}:`, error);
      const errorMessage = error.response?.data?.message || error.message || 'Failed to upload file. Please try again.';

      setUploadErrors((prev) => ({
        ...prev,
        [key]: errorMessage
      }));

      showAlert('Upload Error', errorMessage, 'error');

      setFiles((prev) => {
        const newFiles = { ...prev };
        delete newFiles[key];
        return newFiles;
      });
    } finally {
      setUploadingFiles((prev) => ({ ...prev, [key]: false }));
    }
  };

  const handleRemoveFile = async (key) => {
    const blobName = fileBlobNames[key];

    if (!blobName) {
      setFiles((prev) => {
        const newFiles = { ...prev };
        delete newFiles[key];
        return newFiles;
      });
      return;
    }

    setDeletingFiles((prev) => ({ ...prev, [key]: true }));

    try {
      console.log('Deleting file with blobName:', blobName);

      await deleteFiles({ filename: blobName });

      setFiles((prev) => {
        const newFiles = { ...prev };
        delete newFiles[key];
        return newFiles;
      });

      setUploadedFiles((prev) => {
        const newFiles = { ...prev };
        delete newFiles[key];
        return newFiles;
      });

      setFileBlobNames((prev) => {
        const newBlobNames = { ...prev };
        delete newBlobNames[key];
        return newBlobNames;
      });

      setUploadErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors[key];
        return newErrors;
      });

      showAlert('Success', 'File removed successfully', 'success');
    } catch (error) {
      console.error('Error deleting file:', error);
      showAlert('Delete Error', 'Failed to delete file. Please try again.', 'error');
    } finally {
      setDeletingFiles((prev) => ({ ...prev, [key]: false }));
    }
  };

  const handleSignatureDrawn = (signatureDataUrl) => {
    console.log('Signature drawn, storing data...');
    setSignatureData(signatureDataUrl);

    if (validationErrors['signature']) {
      setValidationErrors((prev) => {
        const updated = { ...prev };
        delete updated['signature'];
        return updated;
      });
    }
  };

  const handleSignatureUpload = async (key) => {
    if (!signatureData) {
      showAlert('Signature Required', 'Please draw your signature first', 'warning');
      return;
    }

    console.log('Uploading signature...');

    setUploadingFiles((prev) => ({ ...prev, signature: true }));

    try {
      const blob = await fetch(signatureData).then(res => res.blob());
      const file = new File([blob], `signature-${Date.now()}.png`, { type: 'image/png' });

      const formData = new FormData();
      formData.append('file', file);

      const response = await upload(formData);

      console.log('Signature upload response:', response);

      let signatureUrl = null;
      let signatureBlobName = null;
      let originalName = null;

      if (response.files && response.files.length > 0) {
        signatureUrl = response.files[0].url;
        signatureBlobName = response.files[0].blobName;
        originalName = response.files[0].originalName;
      } else if (response.data && response.data.files && response.data.files.length > 0) {
        signatureUrl = response.data.files[0].url;
        signatureBlobName = response.data.files[0].blobName;
        originalName = response.data.files[0].originalName;
      } else if (response.file) {
        signatureUrl = response.file.url;
        signatureBlobName = response.file.blobName;
        originalName = response.file.originalName;
      } else if (response.data && response.data.file) {
        signatureUrl = response.data.file.url;
        signatureBlobName = response.data.file.blobName;
        originalName = response.data.file.originalName;
      } else if (response.data) {
        signatureUrl = response.data.url;
        signatureBlobName = response.data.blobName;
        originalName = response.data.originalName;
      }

      if (!signatureUrl || typeof signatureUrl !== 'string') {
        throw new Error('Signature uploaded but URL not found in response');
      }

      if (!signatureBlobName || typeof signatureBlobName !== 'string') {
        throw new Error('Signature uploaded but blobName not found in response');
      }

      setUploadedFiles((prev) => ({
        ...prev,
        'signatures.investigator': { filename: signatureBlobName, originalName }
      }));

      setFileBlobNames((prev) => ({
        ...prev,
        'signatures.investigator': signatureBlobName
      }));

      setSignatures((prev) => ({ ...prev, [key]: signatureUrl }));

      console.log('Signature URL stored:', signatureUrl);
      console.log('Signature blobName stored:', signatureBlobName);
      console.log('Signature originalName stored:', originalName);
      showAlert('Success', 'Signature uploaded successfully', 'success');

      if (validationErrors['signature']) {
        setValidationErrors((prev) => {
          const updated = { ...prev };
          delete updated['signature'];
          return updated;
        });
      }
    } catch (error) {
      console.error('Error uploading signature:', error);
      showAlert('Upload Error', 'Failed to upload signature. Please try again.', 'error');
    } finally {
      setUploadingFiles((prev) => ({ ...prev, signature: false }));
    }
  };

  const handleSignatureClear = async () => {
    const signatureBlobName = fileBlobNames['signatures.investigator'];

    if (signatureBlobName) {
      setDeletingFiles((prev) => ({ ...prev, signature: true }));

      try {
        console.log('Deleting signature with blobName:', signatureBlobName);

        await deleteFiles({ filename: signatureBlobName });

        setSignatures((prev) => ({ ...prev, investigator: null }));
        setSignatureData(null);

        setUploadedFiles((prev) => {
          const newFiles = { ...prev };
          delete newFiles['signatures.investigator'];
          return newFiles;
        });

        setFileBlobNames((prev) => {
          const newBlobNames = { ...prev };
          delete newBlobNames['signatures.investigator'];
          return newBlobNames;
        });

        showAlert('Success', 'Signature cleared successfully', 'success');
      } catch (error) {
        console.error('Error deleting signature:', error);
        showAlert('Delete Error', 'Failed to delete signature. Please try again.', 'error');
      } finally {
        setDeletingFiles((prev) => ({ ...prev, signature: false }));
      }
    } else {
      setSignatureData(null);
    }
  };

  const formatLabel = (key) => {
    return key
      .split('_')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  const scrollToSection = (sectionRef) => {
    if (sectionRef && sectionRef.current) {
      sectionRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
      setTimeout(() => {
        window.scrollBy(0, -100);
      }, 300);
    }
  };

  const renderField = (key, field, parentKey = '') => {
    const fullKey = parentKey ? `${parentKey}.${key}` : key;
    const fieldKey = fullKey;
    const hasError = validationErrors[fieldKey];

    if (field?.type === 'text_box') {
      return (
        <div key={fullKey}>
          <label className={styles.label}>
            {formatLabel(key)}
            {field.required && <span className={styles.required}>*</span>}
          </label>
          {field.requirement && (
            <p className={styles.requirement}>({field.requirement})</p>
          )}
          <input
            type='text'
            value={formData[fieldKey] || ''}
            name={fieldKey}
            disabled={field?.disable || false}
            onChange={(e) => handleInputChange(fieldKey, e.target.value)}
            className={`${styles.input} ${hasError ? styles.inputError : ''}`}
            placeholder={`Enter ${formatLabel(key).toLowerCase()}`}
          />
          {hasError && (
            <p className={styles.errorText}>
              <AlertCircle className={styles.errorIconSmall} />
              {hasError}
            </p>
          )}
        </div>
      );
    } else if (field?.type === 'file_upload') {
      const isUploading = uploadingFiles[fullKey];
      const isDeleting = deletingFiles[fullKey];
      const isUploaded = uploadedFiles[fullKey];
      const error = uploadErrors[fullKey];
      const hasFileError = validationErrors[fullKey];

      return (
        <div key={fullKey}>
          <label className={styles.label}>
            {formatLabel(key)}
            {field.required && <span className={styles.required}>*</span>}
          </label>
          {field.requirement && (
            <p className={styles.requirement}>({field.requirement})</p>
          )}
          <div className={styles.fileInputWrapper}>
            <input
              type='file'
              onChange={(e) => handleFileChange(fullKey, e.target.files[0])}
              className={styles.fileInputHidden}
              id={fullKey}
              disabled={isUploading || isDeleting}
              accept="*/*"
            />
            <label
              htmlFor={fullKey}
              className={`${styles.fileInputLabel} ${(isUploading || isDeleting) ? styles.fileInputDisabled : ''}`}
            >
              {isUploading ? (
                <>
                  <Loader className={`${styles.icon} ${styles.spinning}`} />
                  Uploading...
                </>
              ) : (
                <>
                  <Upload className={styles.icon} />
                  Choose File
                </>
              )}
            </label>
            {files[fullKey] && !error && (
              <div className={styles.fileNameWrapper}>
                <span className={`${styles.fileName} ${isUploaded ? styles.fileNameSuccess : ''}`}>
                  {files[fullKey].name}
                  {isUploaded && ' ✓'}
                </span>
                <button
                  type="button"
                  onClick={() => handleRemoveFile(fullKey)}
                  className={styles.removeFileButton}
                  title="Remove file"
                  disabled={isDeleting}
                >
                  {isDeleting ? (
                    <Loader className={styles.spinningSmall} size={16} />
                  ) : (
                    <Trash2 size={16} />
                  )}
                </button>
              </div>
            )}
            {error && (
              <span className={styles.fileError}>
                <AlertCircle className={styles.errorIcon} />
                {error}
              </span>
            )}
            {hasFileError && (
              <p className={styles.errorText}>
                <AlertCircle className={styles.errorIconSmall} />
                {hasFileError}
              </p>
            )}
          </div>
        </div>
      );
    } else if (field?.type === 'date_field') {
      return (
        <div key={fullKey}>
          <label className={styles.label}>
            {formatLabel(key)}
            {field.required && <span className={styles.required}>*</span>}
          </label>
          <input
            type='date'
            name={fieldKey}
            value={formData[fieldKey] || ''}
            onChange={(e) => handleInputChange(fieldKey, e.target.value)}
            className={`${styles.input} ${hasError ? styles.inputError : ''}`}
          />
          {hasError && (
            <p className={styles.errorText}>
              <AlertCircle className={styles.errorIconSmall} />
              {hasError}
            </p>
          )}
        </div>
      );
    } else if (field?.type === 'electronic_signature') {
      const signatureKey = fullKey.split('.').pop();
      const isUploadingSignature = uploadingFiles['signature'];
      const isDeletingSignature = deletingFiles['signature'];
      const isSignatureUploaded = signatures[signatureKey];

      return (
        <div key={fullKey} className={styles.signatureSection}>
          <SignatureCanvas
            label={formatLabel(key)}
            required={field.required}
            onSignatureChange={handleSignatureDrawn}
            onSignatureClear={handleSignatureClear}
            disabled={isUploadingSignature || isDeletingSignature}
          />

          {signatureData && !isSignatureUploaded && (
            <div className={styles.signatureActions}>
              <button
                type="button"
                onClick={() => handleSignatureUpload(signatureKey)}
                className={styles.uploadSignatureButton}
                disabled={isUploadingSignature}
              >
                {isUploadingSignature ? (
                  <>
                    <Loader className={`${styles.icon} ${styles.spinning}`} />
                    Uploading Signature...
                  </>
                ) : (
                  <>
                    <Upload className={styles.icon} />
                    Upload Signature
                  </>
                )}
              </button>
            </div>
          )}

          {isSignatureUploaded && (
            <div className={styles.signatureUploaded}>
              <CheckCircle className={styles.successIcon} />
              <span>Signature uploaded successfully</span>
            </div>
          )}

          <div className={styles.grid}>
            {Object.entries(field)
              .filter(([k]) => k !== 'type' && k !== 'required' && k !== 'name')
              .map(([subKey, subValue]) =>
                renderField(subKey, subValue, fullKey)
              )}
          </div>
        </div>
      );
    }
    return null;
  };

  const renderSection = (sectionKey, sectionData) => {
    if (typeof sectionData !== 'object' || Array.isArray(sectionData))
      return null;
    return (
      <div className={styles.grid}>
        {Object.entries(sectionData).map(([key, value]) => {
          if (value?.type) {
            return renderField(key, value, sectionKey);
          } else if (
            value &&
            typeof value === 'object' &&
            !Array.isArray(value)
          ) {
            return (
              <div key={key} className={styles.nestedSection}>
                <h4 className={styles.sectionSubtitle}>{formatLabel(key)}</h4>
                <div className={styles.grid}>
                  {Object.entries(value).map(([subKey, subValue]) =>
                    renderField(subKey, subValue, `${sectionKey}.${key}`)
                  )}
                </div>
              </div>
            );
          }
          return null;
        })}
      </div>
    );
  };

  const renderInfoList = (items, title = '') => (
    <div className={styles.infoList}>
      {title && <h4 className={styles.infoListTitle}>{title}</h4>}
      <ul className={styles.list}>
        {items.map((item, idx) => (
          <li key={idx} className={styles.listItem}>
            <span className={styles.bullet}>•</span>
            <span>{item}</span>
          </li>
        ))}
      </ul>
    </div>
  );

  const renderInfoObject = (obj, title = '') => (
    <div className={styles.infoObject}>
      {title && <h4 className={styles.infoListTitle}>{title}</h4>}
      {Object.entries(obj).map(([key, value]) => (
        <div key={key} className={styles.infoObjectItem}>
          <span className={styles.infoObjectKey}>{formatLabel(key)}:</span>
          <span className={styles.infoObjectValue}>{value}</span>
        </div>
      ))}
    </div>
  );

  const validateForm = () => {
    const errors = {};
    let firstErrorSection = null;

    console.log('===== FORM VALIDATION =====');
    console.log('Form Data:', formData);
    console.log('Uploaded Files:', uploadedFiles);
    console.log('Signatures:', signatures);

    const stillUploading = Object.values(uploadingFiles).some(status => status);
    if (stillUploading) {
      showAlert('Upload in Progress', 'Please wait for all files to finish uploading.', 'warning');
      return false;
    }

    const hasUploadErrors = Object.values(uploadErrors).some(error => error);
    if (hasUploadErrors) {
      showAlert('Upload Errors', 'Please fix file upload errors before submitting.', 'error');
      return false;
    }

    const investigatorFields = {
      'investigator.full_name': 'Full name is required',
      'investigator.site_code_&_site_name': 'Site code & site name is required',
      'investigator.medical_registration_no': 'Medical registration number is required'
    };

    Object.entries(investigatorFields).forEach(([fieldKey, errorMessage]) => {
      if (!formData[fieldKey] || formData[fieldKey].trim() === '') {
        errors[fieldKey] = errorMessage;
        if (!firstErrorSection) firstErrorSection = investigatorSectionRef;
      }
    });

    const paymentFields = {
      'personal_information.full_name': 'Full name (as per PAN) is required',
      'personal_information.clinic_address': 'Clinic address is required',
      'personal_information.contact_number': 'Contact number is required',
      'personal_information.alternate_email_address': 'Email address is required',
      'bank_details.bank_name_address': 'Bank name & address is required',
      'bank_details.account_holder_name': 'Account holder name is required',
      'bank_details.account_number': 'Account number is required',
      'bank_details.IFSC_code': 'IFSC code is required'
    };

    Object.entries(paymentFields).forEach(([fieldKey, errorMessage]) => {
      if (!formData[fieldKey] || formData[fieldKey].trim() === '') {
        errors[fieldKey] = errorMessage;
        if (!firstErrorSection) firstErrorSection = paymentSectionRef;
      }
    });

    const requiredFiles = {
      'personal_information.medical_registration_number': 'Medical registration certificate is required',
      'personal_information.pan_number': 'PAN card is required',
      'bank_details.cancelled_cheque': 'Cancelled cheque is required'
    };

    Object.entries(requiredFiles).forEach(([fileKey, errorMessage]) => {
      const fileUrl = uploadedFiles[fileKey]?.filename;

      if (!fileUrl || typeof fileUrl !== 'string' || fileUrl.trim() === '') {
        errors[fileKey] = errorMessage;
        if (!firstErrorSection) firstErrorSection = paymentSectionRef;
      }
    });

    if (!signatures.investigator) {
      errors['signature'] = 'Signature is required';
      if (!firstErrorSection) firstErrorSection = signatureSectionRef;
    }

    console.log('Total errors:', Object.keys(errors).length);
    console.log('===== END VALIDATION =====');

    setValidationErrors(errors);

    if (Object.keys(errors).length > 0) {
      showAlert('Validation Error', 'Please fill in all required fields', 'error');
      if (firstErrorSection) {
        scrollToSection(firstErrorSection);
      }
      return false;
    }

    return true;
  };
  const dataURLtoBlob = (dataURL) => {
    const parts = dataURL.split(',');
    const contentType = parts[0].match(/:(.*?);/)[1];
    const raw = window.atob(parts[1]);
    const rawLength = raw.length;
    const uInt8Array = new Uint8Array(rawLength);

    for (let i = 0; i < rawLength; ++i) {
      uInt8Array[i] = raw.charCodeAt(i);
    }

    return new Blob([uInt8Array], { type: contentType });
  };

  const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const base64String = reader.result.split(',')[1];
        resolve(base64String);
      };
      reader.onerror = (error) => reject(error);
    });
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setIsSubmitting(true);
  //   setSubmitError(null);

  //   console.log('========== SUBMIT START ==========');

  //   try {
  //     const flattenedData = {};
  //     Object.keys(formData).forEach(key => {
  //       flattenedData[key] = formData[key];
  //     });

  //     const reverseDocumentMapping = {
  //       'personal_information.pan_number': 'pancard',
  //       'personal_information.medical_registration_number': 'medical_registration',
  //       'bank_details.cancelled_cheque': 'cancelled_cheque',
  //       'signatures.investigator': 'investigator_signature'
  //     };

  //     const uploadedDocsObject = {};

  //     Object.keys(fileBlobNames).forEach(key => {
  //       const backendKey = reverseDocumentMapping[key] || key;
  //       const blobName = fileBlobNames[key];
  //       const originalName = uploadedFiles[key]?.originalName || files[key]?.name || blobName;

  //       uploadedDocsObject[backendKey] = {
  //         filename: blobName,
  //         originalName: originalName
  //       };
  //     });

  //     console.log('Uploaded docs object:', uploadedDocsObject);

  //     const newFilesBase64 = {};

  //     for (const key of Object.keys(files)) {
  //       if (files[key] && files[key].size > 0) {
  //         const backendKey = reverseDocumentMapping[key] || key;
  //         console.log(`Converting file to base64: ${backendKey}`);
  //         const base64 = await fileToBase64(files[key]);
  //         newFilesBase64[backendKey] = {
  //           data: base64,
  //           name: files[key].name,
  //           type: files[key].type
  //         };
  //       }
  //     }

  //     if (signatures.investigator && signatures.investigator.startsWith('data:image')) {
  //       console.log('Converting signature to base64');
  //       const base64 = signatures.investigator.split(',')[1];
  //       newFilesBase64['investigator_signature'] = {
  //         data: base64,
  //         name: `signature-${Date.now()}.png`,
  //         type: 'image/png'
  //       };
  //     }

  //     const payload = {
  //       userId: parseInt(userId, 10),
  //       consentId: parseInt(consentId, 10),
  //       consentSubmission: flattenedData,
  //       uploaded_docs: uploadedDocsObject
  //     };

  //     if (isResubmission && userConsentId) {
  //       payload.user_consent_id = parseInt(userConsentId, 10);
  //       console.log('Adding user_consent_id for resubmission:', payload.user_consent_id);
  //     }

  //     if (Object.keys(newFilesBase64).length > 0) {
  //       // payload.new_files = newFilesBase64;
  //       console.log('New files to upload:', Object.keys(newFilesBase64));
  //     }

  //     console.log('Final payload:', payload);
  //     console.log('userId type:', typeof payload.userId);
  //     console.log('consentId type:', typeof payload.consentId);
  //     console.log('user_consent_id type:', typeof payload.user_consent_id);

  //     const response = await createConsent(payload);

  //     console.log('Submit response:', response);

  //     if (response.success || response.data?.success || response.message === 'Consent submitted successfully') {
  //       setSnackbar({
  //         show: true,
  //         message: isResubmission
  //           ? 'Consent resubmitted successfully! Redirecting...'
  //           : 'Consent submitted successfully! Redirecting...',
  //         type: 'success'
  //       });

  //       // setTimeout(() => {
  //       //   navigate('/consent-manager');
  //       // }, 2000);
  //       setTimeout(() => {
  //         navigate('/consent-manager', {
  //           state: {
  //             fromResubmission: true
  //           }
  //         });
  //       }, 2000);
  //     } else {
  //       throw new Error(response.message || 'Submission failed');
  //     }

  //   } catch (error) {
  //     console.error('Submit error:', error);
  //     setSubmitError(error.response?.data?.message || error.message || 'Failed to submit consent. Please try again.');
  //     setSnackbar({
  //       show: true,
  //       message: error.response?.data?.message || error.message || 'Failed to submit consent',
  //       type: 'error'
  //     });
  //   } finally {
  //     setIsSubmitting(false);
  //     console.log('========== SUBMIT END ==========');
  //   }
  // };
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setIsSubmitting(true);
    setSubmitError(null);

    console.log('========== SUBMIT START ==========');

    try {
      const userDetails = JSON.parse(localStorage.getItem('user')) || {};
      const currentUserId = userDetails.userId;
      const studyId = userDetails.study?.studyId || userDetails.studyId;

      console.log('🔍 User from localStorage:', userDetails);
      console.log('🔍 Current userId:', currentUserId);
      console.log('🔍 Study ID:', studyId);
      console.log('🔍 Current consentId from state:', consentId);
      console.log('🔍 Current userConsentId from state:', userConsentId);
      console.log('🔍 Is resubmission?', isResubmission);

      if (!currentUserId) {
        throw new Error('User ID not found. Please login again.');
      }

      const flattenedData = {};
      Object.keys(formData).forEach(key => {
        if (formData[key] && formData[key].trim() !== '') {
          flattenedData[key] = formData[key];
        }
      });

      console.log('Flattened form data:', flattenedData);

      const reverseDocumentMapping = {
        'personal_information.pan_number': 'pancard',
        'personal_information.medical_registration_number': 'medical_registration',
        'bank_details.cancelled_cheque': 'cancelled_cheque',
        'signatures.investigator': 'investigator_signature'
      };

      const uploadedDocsObject = {};

      Object.keys(fileBlobNames).forEach(key => {
        const backendKey = reverseDocumentMapping[key] || key;
        const blobName = fileBlobNames[key];
        const originalName = uploadedFiles[key]?.originalName || files[key]?.name || blobName;

        uploadedDocsObject[backendKey] = {
          filename: blobName,
          originalName: originalName
        };
      });

      console.log('Uploaded docs object:', uploadedDocsObject);

      const finalConsentId = consentId || studyId;

      if (!finalConsentId) {
        throw new Error('Consent ID not found. Please refresh the page and try again.');
      }

      const payload = {
        userId: parseInt(currentUserId, 10),
        consentId: parseInt(finalConsentId, 10),
        consentSubmission: flattenedData,
        uploaded_docs: uploadedDocsObject
      };

      if (isResubmission && userConsentId) {
        payload.user_consent_id = parseInt(userConsentId, 10);
        console.log('Adding user_consent_id for resubmission:', payload.user_consent_id);
      }

      console.log('Final payload:', JSON.stringify(payload, null, 2));

      const response = await createConsent(payload);

      console.log('Submit response:', response);

      if (
        response.success ||
        response.data?.success ||
        response.message === 'Consent submitted successfully' ||
        response.message === 'Consent created' ||
        response.data?.message === 'Consent created'
      ) {
        setSnackbar({
          show: true,
          message: isResubmission
            ? 'Consent resubmitted successfully! Redirecting...'
            : 'Consent submitted successfully! Redirecting...',
          type: 'success'
        });

        setTimeout(() => {
          navigate('/consent-manager', {
            state: {
              fromResubmission: isResubmission
            },
            replace: true
          });
        }, 2000);
      } else {
        throw new Error(response.message || 'Submission failed');
      }

    } catch (error) {
      console.error('Submit error:', error);

      if (
        error.message === 'Consent created' ||
        error.message === 'Consent submitted successfully' ||
        error.response?.data?.message === 'Consent created'
      ) {
        setSnackbar({
          show: true,
          message: isResubmission
            ? 'Consent resubmitted successfully! Redirecting...'
            : 'Consent submitted successfully! Redirecting...',
          type: 'success'
        });

        setTimeout(() => {
          navigate('/consent-manager', {
            state: {
              fromResubmission: isResubmission
            },
            replace: true
          });
        }, 2000);
      } else {
        setSubmitError(error.response?.data?.message || error.message || 'Failed to submit consent. Please try again.');
        setSnackbar({
          show: true,
          message: error.response?.data?.message || error.message || 'Failed to submit consent',
          type: 'error'
        });
      }
    } finally {
      setIsSubmitting(false);
      console.log('========== SUBMIT END ==========');
    }
  };
  const handleCloseSuccessModal = () => {
    console.log('Closing success modal and navigating...');

    setShowSuccessModal(false);

    setFormData({});
    setFiles({});
    setUploadedFiles({});
    setFileBlobNames({});
    setSignatures({
      investigator: null,
      authorized_signatory_cro: null,
    });
    setSignatureData(null);
    setValidationErrors({});

    console.log('Form data cleared, calling onSubmitSuccess...');

    if (onSubmitSuccess) {
      onSubmitSuccess();
    }
  };

  if (isLoading) {
    return (
      <div className={styles.container}>
        <div className={styles.loadingWrapper}>
          <Loader className={`${styles.loadingIcon} ${styles.spinning}`} />
          <p className={styles.loadingText}>Loading form data...</p>
        </div>
      </div>
    );
  }

  if (fetchError) {
    return (
      <div className={styles.container}>
        <div className={styles.errorWrapper}>
          <AlertCircle className={styles.errorIconLarge} />
          <h2 className={styles.errorTitle}>Failed to Load Form</h2>
          <p className={styles.errorMessage}>{fetchError}</p>
          <button
            onClick={() => window.location.reload()}
            className={styles.retryButton}
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  if (!jsonResponse) {
    return null;
  }

  return (
    <>
      <div className={styles.container}>
        <div className={styles.wrapper}>
          <div className={styles.card}>
            <div className={styles.header}>
              <FileText className={styles.headerIcon} />
              <div className={styles.headerContent}>
                <h1 className={styles.title}>{jsonResponse.document_title}</h1>
                <div className={styles.studyBox}>
                  <p className={styles.studyLabel}>Study Title:</p>
                  <p className={styles.studyTitle}>{jsonResponse.study_title}</p>
                </div>
              </div>
            </div>
          </div>

          {isResubmission && rejectionReason && (
            <div className={styles.rejectionBanner}>
              <AlertCircle className={styles.rejectionIcon} />
              <div className={styles.rejectionContent}>
                <h3 className={styles.rejectionTitle}>Consent was Rejected</h3>
                <p className={styles.rejectionReason}><strong>Reason:</strong> {rejectionReason}</p>
                <p className={styles.rejectionNote}>Please review and correct the issues mentioned above before resubmitting.</p>
              </div>
            </div>
          )}

          {jsonResponse.parties?.service_provider && (
            <div className={styles.card}>
              <div className={styles.sectionHeader}>
                <Info className={styles.sectionIcon} />
                <h2 className={styles.sectionTitle}>Service Provider</h2>
              </div>
              <p className={styles.infoText}>
                <span className={styles.infoLabel}>Name:</span>{' '}
                {jsonResponse.parties.service_provider.name}
              </p>
              <p className={styles.infoText}>
                <span className={styles.infoLabel}>Address:</span>{' '}
                {jsonResponse.parties.service_provider.address}
              </p>
            </div>
          )}

          {jsonResponse.parties?.investigator && (
            <div className={styles.card} ref={investigatorSectionRef}>
              <h2 className={styles.sectionTitle}>Investigator Information</h2>
              {renderSection('investigator', jsonResponse.parties.investigator)}
            </div>
          )}

          {jsonResponse.sections?.scope_of_services && (
            <div className={styles.card}>
              <h2 className={styles.sectionTitle}>Scope of Services</h2>
              {jsonResponse.sections.scope_of_services.patient_enrollment &&
                renderInfoObject(
                  jsonResponse.sections.scope_of_services.patient_enrollment
                )}
              {jsonResponse.sections.scope_of_services.data_entry &&
                renderInfoObject(jsonResponse.sections.scope_of_services.data_entry)}
              {jsonResponse.sections.scope_of_services.compliance?.standards &&
                renderInfoList(
                  jsonResponse.sections.scope_of_services.compliance.standards,
                  'Compliance Standards'
                )}
            </div>
          )}

          {jsonResponse.sections?.compensation && (
            <div className={styles.card}>
              <h2 className={styles.sectionTitle}>Compensation Details</h2>
              <div className={styles.compensationBox}>
                <p className={styles.compensationAmount}>
                  {jsonResponse.sections.compensation.fee_per_patient}
                </p>
              </div>

              {jsonResponse.sections.compensation.payment_conditions &&
                renderInfoList(
                  jsonResponse.sections.compensation.payment_conditions,
                  'Payment Conditions'
                )}
            </div>
          )}

          {jsonResponse.sections?.confidentiality && (
            <div className={styles.card}>
              <div className={styles.sectionHeader}>
                <AlertCircle className={styles.alertIcon} />
                <h2 className={styles.sectionTitle}>Confidentiality Agreement</h2>
              </div>
              <div className={styles.alertBox}>
                {renderInfoList(jsonResponse.sections.confidentiality)}
              </div>
            </div>
          )}

          {jsonResponse.data_protection && (
            <div className={styles.card}>
              <div className={styles.sectionHeader}>
                <AlertCircle className={styles.warningIcon} />
                <h2 className={styles.sectionTitle}>Data Protection</h2>
              </div>
              <div className={styles.warningBox}>
                {jsonResponse.data_protection.requirements &&
                  renderInfoList(
                    jsonResponse.data_protection.requirements,
                    'Requirements'
                  )}
                {jsonResponse.data_protection.security_responsibilities &&
                  renderInfoList(
                    jsonResponse.data_protection.security_responsibilities,
                    'Security Responsibilities'
                  )}
              </div>
            </div>
          )}

          {jsonResponse.independent_contractor && (
            <div className={styles.card}>
              <h2 className={styles.sectionTitle}>Independent Contractor Status</h2>
              <p className={styles.infoText}>
                <span className={styles.infoLabel}>Status:</span>{' '}
                {jsonResponse.independent_contractor.status}
              </p>
              <p className={styles.infoText}>
                <span className={styles.infoLabel}>Responsibilities:</span>{' '}
                {jsonResponse.independent_contractor.responsibilities}
              </p>
            </div>
          )}

          {jsonResponse.term_termination && (
            <div className={styles.card}>
              <h2 className={styles.sectionTitle}>Term & Termination</h2>
              <p className={styles.infoText}>
                {jsonResponse.term_termination.duration}
              </p>
            </div>
          )}

          {jsonResponse.governing_law && (
            <div className={styles.card}>
              <h2 className={styles.sectionTitle}>Governing Law</h2>
              <p className={styles.infoText}>
                {jsonResponse.governing_law.jurisdiction}
              </p>
            </div>
          )}

          {jsonResponse.payment_verification_details && (
            <div className={styles.card} ref={paymentSectionRef}>
              <h2 className={styles.sectionTitle}>Payment Verification Details</h2>
              {jsonResponse.payment_verification_details.personal_information && (
                <>
                  <h3 className={styles.subsectionTitle}>Personal Information</h3>
                  {renderSection(
                    'personal_information',
                    jsonResponse.payment_verification_details.personal_information
                  )}
                </>
              )}
              {jsonResponse.payment_verification_details.bank_details && (
                <>
                  <h3
                    className={`${styles.subsectionTitle} ${styles.subsectionTitleSpaced}`}
                  >
                    Bank Details
                  </h3>
                  {renderSection(
                    'bank_details',
                    jsonResponse.payment_verification_details.bank_details
                  )}
                </>
              )}
              {jsonResponse.payment_verification_details.data_usage_note && (
                <p className={styles.noteText}>
                  {jsonResponse.payment_verification_details.data_usage_note}
                </p>
              )}
            </div>
          )}

          {jsonResponse.signatures && (
            <div className={styles.card} ref={signatureSectionRef}>
              <h2 className={styles.sectionTitle}>Signatures</h2>
              {validationErrors['signature'] && (
                <div className={styles.signatureError}>
                  <AlertCircle className={styles.errorIconSmall} />
                  {validationErrors['signature']}
                </div>
              )}
              {renderSection('signatures', jsonResponse.signatures)}
            </div>
          )}

          <div className={styles.submitWrapper}>
            <button
              onClick={handleSubmit}
              className={styles.submitButton}
              disabled={isSubmitting || Object.values(uploadingFiles).some(status => status)}
            >
              {isSubmitting ? (
                <>
                  <Loader className={`${styles.buttonIcon} ${styles.spinning}`} />
                  {isResubmission ? 'Resubmitting...' : 'Submitting...'}
                </>
              ) : (
                <>
                  {isResubmission ? 'Resubmit Service Agreement' : 'Submit Service Agreement'}
                </>
              )}
            </button>
          </div>

          <div className={styles.footer}>
            <p>
              All details will be stored securely and used only for administrative
              purposes.
            </p>
          </div>
        </div>
      </div>

      {showSuccessModal && (
        <div className={styles.modalOverlay}>
          <div className={styles.modalContent}>
            <button
              className={styles.modalClose}
              onClick={handleCloseSuccessModal}
              aria-label="Close"
            >
              <X size={24} />
            </button>

            <div className={styles.modalIcon}>
              <CheckCircle size={64} />
            </div>

            <h2 className={styles.modalTitle}>
              {isResubmission ? 'Consent Resubmitted Successfully' : 'Consent Submitted Successfully'}
            </h2>

            <div className={styles.modalBody}>
              <p>Your consent has been submitted for review and is currently awaiting verification.</p>
              <p>You will receive a notification once the review is completed.</p>
              <p className={styles.modalWarning}>
                Please wait for the approval before proceeding with subject creation or data entry.
              </p>
            </div>

            <button
              className={styles.modalButton}
              onClick={handleCloseSuccessModal}
            >
              Close
            </button>
          </div>
        </div>
      )}

      {showAlertModal && (
        <div className={styles.modalOverlay}>
          <div className={styles.modalContent}>
            <div className={styles.modalHeader}>
              <h3 className={styles.modalTitle}>{alertModal.title}</h3>
              <button
                className={styles.modalCloseButton}
                onClick={() => setShowAlertModal(false)}
                aria-label="Close"
              >
                <X size={24} />
              </button>
            </div>
            <div className={styles.modalBody}>
              <p>{alertModal.message}</p>
            </div>
            <div className={styles.modalFooter}>
              <button
                className={styles.modalButton}
                onClick={() => setShowAlertModal(false)}
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}